// Dayjs
import dayjs from 'dayjs'
import 'dayjs/locale/es'
import 'dayjs/locale/fr'
import 'dayjs/locale/it'
import 'dayjs/locale/pt'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

export const locales: Record<Locale, string> = {
  en: 'en-GB',
  fr: 'fr-FR',
  it: 'it-IT',
}

export const formatDate: (format: 'short' | 'long', locale: Locale, d: string) => string = (format, locale, d) => {
  const options =
    format === 'short'
      ? ({
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        } as const)
      : ({
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        } as const)

  return new Date(d).toLocaleDateString(locales[locale], options)
}

/**
 * Returns the string of relative time from now in the given Locale.
 * @param {string} date The date to calculate distance in time to.
 * @param {Locale} lang The language to return the relative time in.
 * @returns
 */
export const fromNow = (date: string, lang: Locale): string => dayjs.utc(date).locale(lang).fromNow()
